import GlobalHeader from "./GlobalHeader";
import BackendPanel from "./BackendPanel";
import PageHeader from "./PageHeader";
import DrawerHeader from "./DrawerHeader";
import SecondaryNav from "./SecondaryNav";

export default {
  GlobalHeader,
  PageHeader,
  BackendPanel,
  DrawerHeader,
  SecondaryNav
};
